var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33329 6.66683V2.66683C9.33329 1.93046 9.93025 1.3335 10.6666 1.3335H21.3333C22.0697 1.3335 22.6666 1.93046 22.6666 2.66683V6.66683H28C28.7364 6.66683 29.3333 7.26379 29.3333 8.00016V26.6668C29.3333 27.4032 28.7364 28.0002 28 28.0002H3.99996C3.26359 28.0002 2.66663 27.4032 2.66663 26.6668V8.00016C2.66663 7.26379 3.26359 6.66683 3.99996 6.66683H9.33329ZM20 9.3335H12V25.3335H20V9.3335ZM9.33329 9.3335H5.33329V25.3335H9.33329V9.3335ZM22.6666 9.3335V25.3335H26.6666V9.3335H22.6666ZM12 4.00016V6.66683H20V4.00016H12Z",
    fill: "#990000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.a321af9bd4064a7408eceb3fc44aa4fd.svg";
export { ForwardRef as ReactComponent };